export { CustomMarker2 as default } from "./CustomMarker2";
